// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sZDo","type":"styles_type__CNcBE","choices":"styles_choices__3e2De"};